import { getTranslation } from 'utils/getTranslation';

import { CATEGORY_ID } from '../constants/categoryId';

const t = getTranslation('products.ProductDetails');

export const mapWoocommerceCategoryName = (category: {
  id: number;
  name: string;
}): string => {
  if (category.id === CATEGORY_ID.UNCATEGORIZED) {
    return `${category.name} (${t('wholeBlood')})`;
  }
  return category.name;
};

export const mapWoocommerceCategories = <
  T extends { id: number; name: string }
>(
  categories: T[]
): T[] => {
  return categories.map((category) => ({
    ...category,
    name: mapWoocommerceCategoryName(category),
  }));
};
